import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import {
    FertilizerEventProduct,
    FertilizerEventUuid,
    RequestCreateFertilizerEventPayload
} from 'services/fertilizerEvents/types';
import {
    requestCreateFertilizerEvent,
    requestUpdateFertilizerEvent
} from 'services/fertilizerEvents/actions';
import {
    FERTILIZER_EVENT_CREATE_NAMESPACE,
    FERTILIZER_EVENT_UPDATE_NAMESPACE
} from 'services/fertilizerEvents/constants';
import FertilizerEventForm from './components/FertilizerEventForm';

interface OwnProps {
    title: string;
    isEditing?: boolean;
}

interface DispatchProps {
    requestCreateFertilizerEvent: typeof requestCreateFertilizerEvent;
    requestUpdateFertilizerEvent: typeof requestUpdateFertilizerEvent;
}
interface ConnectedProps {
    fertilizerEventUuid?: FertilizerEventUuid;
}

type Props = ConnectedProps & OwnProps & DispatchProps;

export class FertilizerEventFinalFormComponent extends React.PureComponent<Props> {
    handleSubmit = (values: RequestCreateFertilizerEventPayload): void => {
        const { isEditing, fertilizerEventUuid, ...props } = this.props;

        const fertilizerProducts: FertilizerEventProduct[] =
            values.fertilizerProducts.map(
                ({ id, units, perUnitType }, index) => ({
                    id,
                    units,
                    perUnitType,
                    orderIndex: index + 1
                })
            );

        if (isEditing && fertilizerEventUuid) {
            props.requestUpdateFertilizerEvent({
                ...values,
                fertilizerProducts,
                endDate: values.startDate,
                uuid: fertilizerEventUuid
            });
        } else {
            props.requestCreateFertilizerEvent({
                ...values,
                fertilizerProducts,
                endDate: values.startDate
            });
        }
    };

    render(): React.ReactElement {
        const { fertilizerEventUuid, isEditing, title } = this.props;

        const namespace = isEditing
            ? FERTILIZER_EVENT_UPDATE_NAMESPACE
            : FERTILIZER_EVENT_CREATE_NAMESPACE;

        return (
            <FertilizerEventForm
                handleSubmit={this.handleSubmit}
                fertilizerEventUuid={fertilizerEventUuid}
                namespace={namespace}
                isEditing={isEditing}
                title={title}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    fertilizerEventUuid: makeSelectQueryStringValue('fertilizerEventUuid')
});

export default connect(mapStateToProps, {
    requestCreateFertilizerEvent,
    requestUpdateFertilizerEvent
})(FertilizerEventFinalFormComponent);
